import { Box, Button } from '@material-ui/core';
import React from 'react';
import { StyledButton } from '../../../../App/Shifamed/Components/forms/presenters/StyledListButton';
import { StyledMenuListIcon } from '../../../../App/Shifamed/Components/forms/presenters/StyledMenuListIcon';
import { StyledMenuListItem } from '../../../../App/Shifamed/Components/forms/presenters/StyledMenuListItem';
import { StyledMenuListItemText } from '../../../../App/Shifamed/Components/forms/presenters/StyledMenuListITemText';
import SM from '../../../../App/Shifamed/Utils/SM/SM';
import { ReactComponent as WithDrawSubmissionIcon } from '../../../../assets/images/withdraw_submission.svg';
import { documentRevisionsActions } from '../../../../state/ducks/documentRevisions';
import { DocumentRevision } from '../../../../state/ducks/documentRevisions/types';
import { AsyncStatus } from '../../../../state/types';
import AlertDialog from '../../../app/alert.dialog/AlertDialog';
import Text from '../../../components/Text';
import FormMessage from '../../../components/forms/FormMessage';
import FormProgress from '../../../components/forms/FormProgress';
import useActionCreator from '../../../hooks/useActionCreator';
import useAsync from '../../../hooks/useAsync';
import useDialog from '../../../hooks/useDialog';

interface Props {
  documentRevision: DocumentRevision
  renderAsButton?: boolean
  label?: string
}

const CloseDeviation: React.FunctionComponent<Props> = ({
  documentRevision,
  renderAsButton,
  label = 'common.close',
}) => {
  const isNewLayout = SM.isNewLayout;
  const dialog = useDialog();
  const closeDeviation = useActionCreator(documentRevisionsActions.closeDeviation);
  const async = useAsync<DocumentRevision>({
    onSuccess: dialog.close,
    onError: dialog.close,
  });

  // Close shows only once every step of the deviation's affected LHRs is complete (ENC-8805 #29)
  const [isReady, setIsReady] = React.useState(false);
  const checkReady = useActionCreator(documentRevisionsActions.isDeviationReadyToClose);
  const readyAsync = useAsync<{ ready: boolean }>({
    onSuccess: (data) => setIsReady(Boolean(data?.ready)),
  });
  React.useEffect(() => {
    readyAsync.start(checkReady, documentRevision.id, readyAsync);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentRevision.id]);

  const onConfirm = () => {
    dialog.close();
    async.start(closeDeviation, documentRevision.id, async);
  };

  const isLoading = async.asyncState.status === AsyncStatus.Active;

  if (!isReady) {
    return null;
  }

  return (
    <>
      <Box position="absolute" marginTop="-50px">
        <FormMessage asyncState={async.asyncState} />
        <FormProgress asyncState={async.asyncState} />
      </Box>
      {isNewLayout ? (
        renderAsButton ? (
          <StyledButton
            color="primary"
            id="close-deviation-button"
            data-cy="close-deviation-button"
            onClick={dialog.open}
            disabled={isLoading}
          >
            <Text message={label} />
          </StyledButton>
        ) : (
          <StyledMenuListItem
            button
            disabled={isLoading}
            alignItems="flex-start"
            onClick={dialog.open}
          >
            <StyledMenuListIcon>
              <WithDrawSubmissionIcon />
            </StyledMenuListIcon>
            <StyledMenuListItemText
              id="close-deviation-button"
              data-cy="close-deviation-button"
              primary={<Text message={label} />}
            />
          </StyledMenuListItem>
        )
      ) : (
        <Button
          id="close-deviation-button"
          data-cy="close-deviation-button"
          variant="outlined"
          color="secondary"
          onClick={dialog.open}
          disabled={isLoading}
        >
          <Text message={label} />
        </Button>
      )}
      <AlertDialog
        confirmAction={onConfirm}
        message="documentRevision.deviation.close.confirm"
        {...{ dialog }}
      />
    </>
  );
};

export default CloseDeviation;
